import { getOrderDetailsByLoanId } from '@nemuru-eng/js-api-client';

import { calculateMaxAmounts } from '@/components/modules/OrderActivity/hooks/useOrderActions/utils/calculateMaxAmounts';
import { getOrderActions } from '@/components/modules/OrderActivity/hooks/useOrderActions/utils/getOrderActions/getOrderActions';
import { useCache } from '@/hooks/requests/useCache';

interface UseCurrentOrderOnParamIdProps {
  loanId: string;
}

export const useCurrentOrderOnParamId = ({ loanId }: UseCurrentOrderOnParamIdProps) => {
  const { data: orderDetails, loading } = useCache(getOrderDetailsByLoanId, { loanId });

  if (!orderDetails) {
    return { actions: undefined, maxToCapture: undefined, maxToRefund: undefined, loading: false };
  }
  const actions = getOrderActions(orderDetails);
  const { maxToCapture, maxToRefund } = calculateMaxAmounts(orderDetails, actions);

  return { actions, orderDetails, maxToCapture, maxToRefund, loading };
};
